import { useState } from "react";
import { PortableText } from "@portabletext/react";

// EN paragraphs get font-outfit on the <p> (matches the original
// .en-desc.font-outfit markup). JP paragraphs are left without a font
// class to mirror the original bare .jp-desc <p> rendering.
const enComponents = {
  block: {
    normal: ({ children }) => <p className="font-outfit">{children}</p>,
  },
  marks: {
    link: ({ value, children }) => (
      <a href={value?.href} className="title-link">
        {children}
      </a>
    ),
  },
};

const jpComponents = {
  block: {
    normal: ({ children }) => <p>{children}</p>,
  },
  marks: {
    link: ({ value, children }) => (
      <a href={value?.href} className="sub-title-link">
        {children}
      </a>
    ),
  },
};

const Description = ({ en, jp }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="about-desc-section">
      <div className={`desc-view ${isOpen ? "full-height" : ""}`}>
        <div className="en-desc font-outfit">
          <PortableText value={en} components={enComponents} />
        </div>
        <hr className="middle-hr" />
        <div className="jp-desc">
          <PortableText value={jp} components={jpComponents} />
        </div>
      </div>
      <button className="showmore-btn" onClick={() => setIsOpen(!isOpen)}>
        {isOpen ? "Show less" : "Show more..."}
      </button>
    </div>
  );
};

export default Description;
